import { WishlistModule } from '../'
import wishlistMountedMixin from '@vue-storefront/core/modules/wishlist/mixins/wishlistMountedMixin'
import { registerModule } from '@vue-storefront/core/lib/modules';

export const Wishlist = {
  name: 'Wishlist',
  mixins: [wishlistMountedMixin],
  created () {
    registerModule(WishlistModule)
  },
  computed: {
    isWishlistOpen () {
      return this.$store.state.ui.wishlist
    },
    productsInWishlist () {
      return this.$store.state.wishlist.items
    }
  },
  methods: {
    removeAllFromMagentoWishlist () {
      this.$store.dispatch('wishlist/clear')
    },
    closeWishlist () {
      this.$store.dispatch('ui/toggleWishlist')
    }
  }
}
